import axios from 'axios';
import {mainStore} from "../stores";
import router from '@/router';
import {API} from '@/services/url';
import toastService from '@/services/toastService';


export const requestInterceptor = function () {
  axios.interceptors.request.use(function(config) {
    if(config.url!=API.auth.signIn){
      if(!mainStore.getters.loggedIn){
        toastService.showErrorToast('Please login again');
        mainStore.dispatch('logOut');
        router.push('/login');
      }else {
        config.headers["Authorization"] = "Bearer "+localStorage.token;
      }

    }
    return config;
  }, function(err) {
    return Promise.reject(err);
  });
};

export const responseInterceptor =  function (){
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // error.response is undefined on a network error, timeout or CORS failure. Reading
    // .status off it threw a TypeError *inside* the interceptor instead of rejecting, which
    // any polling page (the log viewer follows every 2s) trips the first time the API blips.
    if(error.response && error.response.status === 401){
      mainStore.dispatch('logOut');
      router.push('/login');
    }
    return Promise.reject(error);
  });

};
